import React from 'react'
import PropTypes from 'prop-types'

const SortHeader = (props) => {
  let classSort = ''
  if (props.param.sortField === props.type) {
    classSort = props.param.sortOrder.toLowerCase()
  }

  const sortField = props.type
  const sortOrder = props.param.sortOrder === 'DESC' ? 'ASC' : 'DESC'

  return (
    <button
      className={`sort-header ${classSort}`}
      onClick={props.handleSort(sortField, sortOrder)}
    >
      {props.label}
    </button>
  )
}

SortHeader.propTypes = {
  label: PropTypes.string.isRequired,
  param: PropTypes.shape({
    searchProfileField: PropTypes.string,
    selectedCountry: PropTypes.string,
    selectedService: PropTypes.string,
    sortField: PropTypes.string,
    sortOrder: PropTypes.string,
    filterStatus: PropTypes.string,
  }).isRequired,
  type: PropTypes.string.isRequired,
  handleSort: PropTypes.func.isRequired,
}

export default SortHeader
